module.exports = __webpack_public_path__ + "static/dunkin-1-5db9e9e97cf9063f51803851948e8888.gif";